// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import QuickOrderState from "@insite/client-framework/Store/Pages/QuickOrder/QuickOrderState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type XProductInfo = ProductInfo & { index?: number };

interface XQuickOrderState extends Omit<QuickOrderState, "productInfos"> {
    productInfos: XProductInfo[];
}

const initialState: XQuickOrderState = {
    productInfos: [],
    total: 0,
};

const reducer = {
    "xMiniQuickOrder/QuickOrder/ClearProducts": (draft: Draft<XQuickOrderState>) => {
        draft.productInfos = [];
    },
    "xMiniQuickOrder/QuickOrder/RemoveProduct": (
        draft: Draft<XQuickOrderState>,
        action: { productId: string; index: number },
    ) => {
        draft.productInfos = draft.productInfos.filter(
            o => !(o.productId === action.productId && o.index === action.index),
        );
    },
    "xMiniQuickOrder/QuickOrder/BeginAddProduct": () => {},
    "xMiniQuickOrder/QuickOrder/CompleteAddProduct": (
        draft: Draft<XQuickOrderState>,
        action: { productInfo: XProductInfo },
    ) => {
        const existingProduct = draft.productInfos.find(
            o =>
                o.index === action.productInfo.index &&
                o.productId === action.productInfo.productId &&
                o.unitOfMeasure === action.productInfo.unitOfMeasure,
        );
        if (!existingProduct) {
            draft.productInfos.unshift(action.productInfo);
        } else {
            existingProduct.pricing = action.productInfo.pricing;
            existingProduct.inventory = action.productInfo.inventory;
            existingProduct.qtyOrdered = action.productInfo.qtyOrdered;
            existingProduct.failedToLoadPricing = action.productInfo.failedToLoadPricing;
        }
    },
};

const xMiniQuickOrder = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xMiniQuickOrder = xMiniQuickOrder;

export type xMiniQuickOrderState = {
    xMiniQuickOrder: XQuickOrderState;
} & ApplicationState;
